import { Controller } from "@hotwired/stimulus"

// Shows a caret at the right edge of a rating table while there are scale points off
// the end of the frame, and hides it once the grid is scrolled to the end.
//
// The horizontal twin of rail_overflow_controller, and deliberately a copy of its
// mechanism rather than a generalisation of it: that one steers the nav rail on every
// page, and widening its contract to take an axis would put this feature's bugs there.
//
// Purely a hint — the caret is decorative and not interactive. Without it a long scale
// simply looks cut off: the frame scrolls, but macOS draws no resting scrollbar, so
// nothing on screen says there is more to the right.
export default class extends Controller {
  static targets = ["frame", "hint"]

  connect() {
    this.update = this.update.bind(this)
    this.frameTarget.addEventListener("scroll", this.update, { passive: true })
    // The frame's own box rarely changes — the canvas fixes its width — so the TABLE is
    // observed too. Adding or removing a column resizes that and nothing else, and it
    // is exactly when the answer changes.
    this.observer = new ResizeObserver(this.update)
    this.observer.observe(this.frameTarget)
    const table = this.frameTarget.querySelector("table")
    if (table) this.observer.observe(table)
    this.update()
  }

  disconnect() {
    this.frameTarget.removeEventListener("scroll", this.update)
    this.observer?.disconnect()
  }

  update() {
    if (!this.hasHintTarget || !this.hasFrameTarget) return

    const frame = this.frameTarget
    const remaining = frame.scrollWidth - frame.scrollLeft - frame.clientWidth
    this.hintTarget.hidden = remaining <= 1
  }
}
